// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__gLKRX","buttonWrapper":"Footer_buttonWrapper__CzGHP"};